<template>
  <div ref="document" class="popup_scan">
   
      
      <div v-if="displayFirst" id="container">
      
      </div>
      

      <img v-if="photoData" :src="photoData" />
      <img v-if="photoData2" :src="photoData2" />
      <img v-if="photoData3" :src="photoData3" />
      
  </div>
  

</template>


<script>
import jQuery from 'jquery';
import {APIRequest} from "@simb2s/senseye-sdk";

import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import { FBXLoader } from 'three/examples/jsm/loaders/FBXLoader.js'
var camera, controls, scene, renderer;

export default {
  components: {  },
  name: 'ScanCanvas',
  props:['scan','view'],
  data() {
    return {
      scanDetail:null,
      center:null,
      camera:null,
      camera2:null,
      camera3:null,
      photoData2:null,
      photoData3:null,
      controls:null,
      displayFirst:true,
      displaySecond:false,
      displayThird:false,
      controls2:null,
      controls3:null,
      scene:null, 
      scene2:null, 
      scene3:null, 
      renderer:null,
      renderer2:null,
      renderer3:null,
      container:null,
      container2:null,
      container3:null,
      geometry:null,
      geometry2:null,
      geometry3:null,
      photoData:null,
      ptcloud_array:[]
    }
  },
  async mounted(){

    

    await this.getScanDetails()

    let coordinates=await APIRequest.get_request('api/scans/point-cloud/'+this.scan.id)
 
    var pointCloud=coordinates.data.pointCloud;
    



    this.ptcloud_array = pointCloud.split(/\r?\n/);

    
      this.container = document.getElementById("container");
      this.container2 = null;
      this.container3 = null;
    
 
    
    this.init()
   
  },
  beforeUnmount() {
        window.removeEventListener('resize', this.onWindowResize);
  },
  methods:{
    closeModal($event)
        {
            
            if(jQuery($event.target).parents('.conent').length)
            {
              
            }
            else
            {
              emitter.emit('hide-popup-scan')
                $event.preventDefault()
            }
            
        },
   
    async getScanDetails() {
      this.scanDetail=this.scan
   
    },
    async doesFileExist(url, timeoutMs = 4000) {
      const controller = new AbortController()
      const timeoutId = setTimeout(() => controller.abort(), timeoutMs)
      try {
        const response = await fetch(url, { method: 'HEAD', signal: controller.signal })
        return response.ok
      } catch (e) {
        return false
      } finally {
        clearTimeout(timeoutId)
      }
    },
    buildPointCloud() {
      const geometry = new THREE.BufferGeometry()
      const points_array = []
      const colors_array = []

      for (let i = 0; i < this.ptcloud_array.length; i++) {
        const points_ex = this.ptcloud_array[i].split(',')
        if (points_ex.length < 6) continue
        points_array.push(points_ex[0], points_ex[1], points_ex[2])
        colors_array.push(points_ex[3], points_ex[4], points_ex[5])
      }

      const points_vertices = new Float32Array(points_array)
      const colors = new Uint8Array(colors_array)
      geometry.setAttribute('position', new THREE.BufferAttribute(points_vertices, 3))
      geometry.setAttribute('color', new THREE.BufferAttribute(colors, 3))
      geometry.attributes.color.normalized = true

      const material = new THREE.PointsMaterial({ vertexColors: true, size: 0.0045 })
      return new THREE.Points(geometry, material)
    },
    captureThreeViewsFromObject(object, directionalLight) {
      const box = new THREE.Box3().setFromObject(object)
      const centerVec = box.getCenter(new THREE.Vector3())
      const sizeVec = box.getSize(new THREE.Vector3())
      const maxDim = Math.max(sizeVec.x, sizeVec.y, sizeVec.z)
      const fov = camera.fov * (Math.PI / 180)
      const cameraDistance = Math.abs(maxDim / (2 * Math.tan(fov / 2))) * 1.5

      camera.near = Math.max(0.01, cameraDistance / 100)
      camera.far = cameraDistance * 100
      camera.updateProjectionMatrix()

      const applyViewAndCapture = (offset, outputKey) => {
        camera.position.set(
          centerVec.x + (offset.x * cameraDistance),
          centerVec.y + (offset.y * cameraDistance),
          centerVec.z + (offset.z * cameraDistance)
        )
        camera.lookAt(centerVec)
        controls.target.copy(centerVec)
        controls.update()

        directionalLight.position.set(
          centerVec.x + (offset.x * cameraDistance * 0.8),
          centerVec.y + (offset.y * cameraDistance * 0.8) + (cameraDistance * 0.2),
          centerVec.z + (offset.z * cameraDistance * 0.8)
        )
        directionalLight.target.position.copy(centerVec)
        scene.add(directionalLight.target)

        renderer.render(scene, camera)
        this[outputKey] = renderer.domElement.toDataURL('image/png')
      }

      // Face
      applyViewAndCapture(new THREE.Vector3(0, 0, 1), 'photoData')
      // Three quarter
      applyViewAndCapture(new THREE.Vector3(1, 0, 1).normalize(), 'photoData2')
      // Side
      applyViewAndCapture(new THREE.Vector3(1, 0, 0), 'photoData3')
    },
    renderPointCloudFallback(directionalLight) {
      const pointCloudMesh = this.buildPointCloud()
      scene.add(pointCloudMesh)
      pointCloudMesh.rotation.y += 1.6
      this.captureThreeViewsFromObject(pointCloudMesh, directionalLight)
      this.displayFirst = false
    },
    init() {

      const scanUrl = 'https://rhino.visages.com/scans/proc/' + this.scan.id + '.fbx';

      renderer = new THREE.WebGLRenderer( { antialias: true, preserveDrawingBuffer: true } );
        
      const targetContainer = this.container;
      renderer.setPixelRatio( window.devicePixelRatio );
      renderer.setSize( targetContainer.offsetWidth, targetContainer.offsetHeight );
      targetContainer.appendChild( renderer.domElement );
      scene = new THREE.Scene();
      scene.background = new THREE.Color( 0xe4e3e1 );
      camera = new THREE.PerspectiveCamera( 15, targetContainer.offsetWidth / targetContainer.offsetHeight, 0.01, 40 );
      scene.add( camera );

      controls = new OrbitControls( camera, renderer.domElement );
      controls.enablePan = false;

      const ambientLight = new THREE.AmbientLight(0xffffff, 0.2)
          scene.add(ambientLight)
          const hemiLight = new THREE.HemisphereLight(0xffffff, 0x444444, 0.3)
          scene.add(hemiLight)
          const directionalLight = new THREE.DirectionalLight(0xffffff, 0.6)
          scene.add(directionalLight)

          const loader = new FBXLoader()
          if (loader.setCrossOrigin) loader.setCrossOrigin('anonymous')
          let fakeProgressInterval = null;

          this.doesFileExist(scanUrl).then((fileExists) => {
            if (!fileExists) {
              this.renderPointCloudFallback(directionalLight)
              return
            }

            loader.load(
              scanUrl,
              (object) => {
                clearInterval(fakeProgressInterval);
                object.scale.setScalar(0.01)
                object.rotation.x = -Math.PI / 2
                scene.add(object)

                object.traverse((child) => {
                  if (child.isMesh && child.material) {
                    const toWhite = (mat) => {
                      const params = {
                        color: 0xffffff,
                        metalness: 0.0,
                        roughness: 0.85,
                        side: mat.side !== undefined ? mat.side : THREE.FrontSide,
                        transparent: mat.transparent === true,
                        opacity: mat.opacity !== undefined ? mat.opacity : 1,
                        skinning: mat.skinning === true,
                        morphTargets: mat.morphTargets === true,
                        morphNormals: mat.morphNormals === true,
                      }
                      const newMat = new THREE.MeshStandardMaterial(params)
                      newMat.needsUpdate = true
                      return newMat
                    }

                    if (Array.isArray(child.material)) {
                      child.material = child.material.map((m) => toWhite(m))
                    } else {
                      child.material = toWhite(child.material)
                    }
                  }
                })

                this.captureThreeViewsFromObject(object, directionalLight)
                this.displayFirst = false
              },
              (xhr) => {
               
              },

              (error) => {
                clearInterval(fakeProgressInterval)
                this.renderPointCloudFallback(directionalLight)
              }
            )
          }).catch(() => {
            this.renderPointCloudFallback(directionalLight)
          })

      window.addEventListener( 'resize', this.onWindowResize, false );
    },
    onWindowResize() {
      if (!camera || !renderer || !controls) return;
      camera.aspect = this.container.offsetWidth / this.container.offsetHeight;
      camera.updateProjectionMatrix();
      renderer.setSize( this.container.offsetWidth, this.container.offsetHeight );
      renderer.render(scene, camera)
    }
    
  },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#photoData,
#photoData2
{
  filter: grayscale(1);
}
  #container {
    background:grey;
      display:inline-block;
      
    width:33.33%;
    height:250px;

    max-height: 410px;
  }
  #container2 {
    background:grey;
      display:inline-block;
    width:33.33%;
    height:250px;
    max-height: 410px;
  }
  #container3 {
    background:grey;
    display:inline-block;
    width:33.33%;
    height:250px;
    max-height: 410px;
  }
  .popup_scan img 
  {
   
    width:33.33%;
  }
  .popup_scan {
    position:relative;
    top:0;
    left:0;
    width:100%;
    
    height:100%;
      
   display:flex;
  }
</style>
